import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const SectionHeading = ({ eyebrow, title, desc, light = false, align = "right" }) => (
  <Reveal className={`mb-10 sm:mb-14 ${align === "center" ? "text-center" : ""}`}>
    {eyebrow && (
      <span
        className={`inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] uppercase mb-4 ${
          light ? "text-red-600" : "text-red-500"
        }`}
      >
        <span className="h-px w-8 bg-current inline-block" />
        {eyebrow}
      </span>
    )}
    <h2
      className={`font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-snug ${
        light ? "text-slate-900" : "text-white"
      }`}
    >
      {title}
    </h2>
    {desc && (
      <p
        className={`mt-4 text-base leading-relaxed max-w-2xl ${
          light ? "text-slate-600" : "text-slate-400"
        } ${align === "center" ? "mx-auto" : ""}`}
      >
        {desc}
      </p>
    )}
  </Reveal>
);
